<div id="color-picker-{{name}}">
    <div fxLayout="row" fxLayoutAlign="start end" class="clickBox" id="clr-{{name}}">
        <forge-label-value attr.telemetry="Submission-{{label}}">
            <span slot="label">{{label}}</span>
            <span slot="value" fxLayout="row">
                <div class="color-square" attr.telemetry="Submission-{{label}}"
                     [ngStyle]="{'background-color': valueModel}" id="clr-box-{{name}}"></div>
                <forge-button [dense]="compact" [hidden]="isViewOnly" variant="outlined"
                              class="popup-target tt-margin--left" attr.telemetry="Submission-{{label}}"
                              [disabled]="isViewOnly" id="clr-btn-{{name}}" #popup="forgePopover"
                              [forgePopover]="popupTemplate" forgePopoverCloseOnBlur="true" (click)="openPopup()">
                    Select color
                </forge-button>
            </span>
            <span slot="helper-text" [hidden]="!hint">{{hint}}</span>
            <span slot="helper-text">{{error}}</span>
        </forge-label-value>
    </div>
</div>

<ng-template #popupTemplate>
    <div #popupContent id="color-picker-{{popupId}}" class="popup-container" (focusout)="focusOut($event)"
         (keyup)="keyUp($event)">
        <div class="popup-card">
            <forge-color-picker [value]="valueModel" [name]="name"
                                (forge-color-picker-change)="fireValueChanged($event.detail)" [rgba]="model" focusOnLoad [propertyMetadata]="propertyMetadata"
                                [forCellEdit]="forCellEdit" allowOpacity="false">
            </forge-color-picker>
        </div>
    </div>
</ng-template>
